import { deepClone } from "@/utils";
import {
  FormatterFn,
  OriginFormFlat,
  OriginFormItem,
  OriginFormModule,
  SL
} from "./type";

export function useOriginFormFlat(
  originFormModule: OriginFormModule,
  visibleState: Record<string, () => boolean>,
  formatterFnMap: Record<string, FormatterFn>,
  modulesVisibleState?: Record<string, () => boolean>
) {
  // 模块隐藏
  if (modulesVisibleState) {
    originFormModule = originFormModule.filter((module) => {
      const hide =
        module.key &&
        modulesVisibleState[module.key] &&
        !modulesVisibleState[module.key]();
      return !hide;
    });
  }
  return originFormModule.reduce((prev, curr) => {
    let colSum = 0;

    prev[curr.title] = curr.children?.reduce(
      (p, c) => {
        const formItem = deepClone(c);
        // 字段隐藏
        if (visibleState) {
          const hide =
            formItem.key &&
            visibleState[formItem.key] &&
            !visibleState[formItem.key]();
          if (hide) {
            return p;
          }
        }
        // 格式化
        if (
          formItem.needFormatter &&
          formatterFnMap &&
          formatterFnMap[c.field]
        ) {
          formItem.formatter = formatterFnMap[c.field];
        }
        colSum += formItem.span || 6;
        // 主动换行
        if (formItem.newline) {
          p.push([formItem]);
          colSum = 0;
          return p;
        }
        // 自动换行
        if (colSum <= 24) {
          p[p.length - 1].push(formItem);
        } else {
          p.push([formItem]);
          colSum = colSum - 24;
        }
        return p;
      },
      [[]] as OriginFormItem[][]
    );
    return prev;
  }, {} as OriginFormFlat);
}

export function optionFormatter(value: string | number, options: SL) {
  const item = options.find((item) => item.value === value);
  return item?.label || item?.text || "-";
}
export function ratioFormatter(val: string | number) {
  if (!val) return "-";
  return `${(Number(val) * 100).toFixed(2)}%`;
}
